<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" hide-footer :onClose="onClose">
    <div class="row">
      <div class="col-12 mb-3 mt-1">
        <div class="generalLabel">
          <div>{{ message }}</div>
        </div>
      </div>
      <div class="col-12">
          <button 
            class="btn btn-primary generalPrimaryButton float-right" 
            @click="onClose()"
            >
              Aceptar
          </button>
      </div>
    </div>
    <button :id="id+'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>
<script>
import Modal from "../../../Shared/Modal.vue";

export default {
  name: "ModalLoadPromotion",
  props: [
    "id",
    "modalTitle",
    "class",
    "message",
  ],
  data() {
    return {
      classes: this.class,
    };
  },
  components: {
    Modal,
  },
  methods: {
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
		},
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>
